<script lang="ts" context="module">
  import {httpClient} from '@/utils/http-client';
  import {writable} from 'svelte/store';
  import {fly} from 'svelte/transition';
  import Swal from 'sweetalert2';
  import {VideoService} from '@/services';

  let currentId: string;
  export const discussionGuideStore = writable({
    loading: false,
    data: null,
    cachedData: null
  });
  const videoService = new VideoService();

  export function downloadDiscussionGuide(id: string) {
    currentId = id;
    discussionGuideStore.set({loading: true, data: null, cachedData: null});
    const errorNoDiscussionGuide = () => {
      discussionGuideStore.set({loading: false, data: null, cachedData: null});
      Swal.fire(
        'Discussion guide is not available for this sermon',
        'Sorry, we apologize for the inconvenience but only newly uploaded sermons have discussion guides available',
        'error'
      );
    };
    const tryDownload = (retries = 0) =>
      httpClient
        .get(`/discussion-guides/${id}`)
        .then(async res => {
          if (res.status == 204 && retries < 100) {
            if (currentId !== id) return;
            return setTimeout(() => {
              tryDownload(retries + 1);
            }, 2000);
          } else if (res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data.result]));
            const link = document.createElement('a');
            const videoName = (await videoService.getVideo(id)).title;
            link.href = url;
            link.setAttribute('download', id + `Discussion Guide of ${videoName}.txt`);
            document.body.appendChild(link);
            link.click();
            discussionGuideStore.set({loading: false, data: res.data, cachedData: res.data});
            setTimeout(() => {
              discussionGuideStore.set({loading: false, data: null, cachedData: res.data});
            }, 4000);
          } else {
            errorNoDiscussionGuide();
          }
        })
        .catch(errorNoDiscussionGuide);
    tryDownload();
  }
</script>

{#if $discussionGuideStore.loading || $discussionGuideStore.data}
  <div
    transition:fly={{y: 20}}
    class="absolute bottom-3 right-4 z-50 rounded-md bg-primary p-4 font-bold text-white shadow-md"
  >
    {#if $discussionGuideStore.loading}
      <span class="text-xs"><span class="fa fa-spinner animate-spin"></span> Loading discussion guide...</span>
    {:else}
      <span class="text-xs"><span class="fa-solid fa-circle-check"></span> Discussion guide has been downloaded</span>
    {/if}
  </div>
{/if}
